import * as React from 'react';
import type { ClockPayload } from '../schema';

const ClockPayloadContext = React.createContext<ClockPayload>({ timeZones: [] } as ClockPayload);
ClockPayloadContext.displayName = 'ClockPayloadContext';

export const ClockPayloadProvider = ClockPayloadContext.Provider;

export function useClockPayload() {
    return React.useContext(ClockPayloadContext);
}
